/* eslint no-shadow: 0 */

export const namespaced = true;

export const state = {
  companyID: '',
  memberSourceID: '',
  bindingMemberSourceID: '',
  memberSourcePairNo: '',
  brandNo: '',
  memberID: '',
  contactID: '',
  accessToken: '',
  showPopup: false,
  showEditMemberSuccessPopup: false,
  showGoLoginPopup: false,
  showStickyPopup: false,
  popupContent: '',
  popupTitle: '',
  popupReloadAction: false,
  showResetPopup: false,
  showForgetPwdPopup: false,
  showForgetPwdSentCodePopup: false,
  showApiErrorPopup: false,
  doTrdPartyLogin: false,
  showRedirectPopup: false,
  isShowLoading: true,
  showregistersuccessPopup: false,
  showPrivacyPolicy: false,
  layoutType: '',
  color: ''
};

export const getters = {
};

export const mutations = {
  setCommonData(state, data) {
    state[data.id] = data.value;
  }
};

export const actions = {
};
